import { ErrorHandler } from '@angular/core';
var GlobalErrorHandler = /** @class */ (function () {
    function GlobalErrorHandler() {
    }
    GlobalErrorHandler.prototype.handleError = function (error) {
        var errorMessage = this._buildErrorMessage(error);
        console.log("%c" + errorMessage, 'background: #FFF; color: #FF0000;');
    };
    GlobalErrorHandler.prototype._buildErrorMessage = function (error) {
        return "Description Error: " + error.message + "\n\nStackTrace: " + error.stack;
    };
    return GlobalErrorHandler;
}());
export { GlobalErrorHandler };
